export const config = {
  title: 'Big M Towing LLC | Reliable Towing & Roadside Assistance in Eutaw, AL',
  meta: {
    description:
      'Big M Towing LLC offers 24/7 towing, recovery, and roadside assistance in Eutaw, AL. Dependable service for cars, trucks, and equipment when you need it most.',
    keywords: [
      'Big M Towing',
      'Eutaw Towing Service',
      'Roadside Assistance AL',
      'Vehicle Recovery',
      'Heavy Duty Towing',
      '24/7 Tow Truck',
      'Alabama Towing Company',
    ],
    author: 'Big M Towing LLC',
    canonicalUrl: 'https://bigmtowing.com/',
  },
  sections: {
    header: {
      businessName: 'Big M Towing LLC',
    },
    sectionB: {
      heroTitle: 'Big M Towing LLC',
      heroSubtitle: '24/7 Towing & Roadside Help in Eutaw, AL',
      learnAboutText: 'Request Emergency Service',
      phoneNumber: '2054962590',
      phoneLabel: '(205) 496-2590',
      heroBackgroundImage:
        'https://bigmtowing.com/wp-content/uploads/2025/03/l-25.jpg',
      cardData: [
        {
          title: '24/7 Emergency Towing',
          description:
            'Fast and reliable towing any time of day or night. We’re ready when you need help most.',
        },
        {
          title: 'Roadside Assistance',
          description:
            'Flat tire, lockout, battery jump? Our team is here to get you back on the road quickly.',
        },
        {
          title: 'Heavy Duty Recovery',
          description:
            'We specialize in heavy-duty towing and equipment recovery with professional-grade trucks.',
        },
      ],
      description:
        'Big M Towing LLC is your go-to provider for reliable towing and roadside assistance in Eutaw, AL. Whether it’s a vehicle breakdown or heavy-duty recovery, our team is always on call to provide fast, professional service.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our full range of towing and roadside assistance solutions.',
      cards: [
        {
          title: 'Towing Services',
          description:
            'Light, medium, and heavy-duty towing solutions to safely transport your vehicle or equipment.',
          imageSrc: 'https://bigmtowing.com/wp-content/uploads/2025/03/l-26.jpg',
          imageAlt: 'Towing Services',
        },
        {
          title: 'Roadside Assistance',
          description:
            'Jump starts, lockouts, tire changes, and more—we’re your emergency roadside team.',
          imageSrc: 'https://bigmtowing.com/wp-content/uploads/2025/03/02.jpg',
          imageAlt: 'Roadside Help',
        },
        {
          title: 'Equipment Transport',
          description:
            'We offer secure transport for tractors, trailers, machinery, and more.',
          imageSrc: 'https://bigmtowing.com/wp-content/uploads/2025/03/01.jpg',
          imageAlt: 'Equipment Transport',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Vehicle Lockouts',
        'Fuel Delivery',
        'Tire Change',
        'Battery Jump Starts',
        'Accident Recovery',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://bigmtowing.com/wp-content/uploads/2025/03/l-31.jpg',
        alt: 'Big M Towing Team',
      },
      aboutText: [
        'Big M Towing LLC is a family-owned and operated towing business proudly serving Eutaw, Alabama and surrounding communities.',
        'With years of experience in both light-duty and heavy-duty towing, our team is committed to delivering honest, timely, and professional assistance around the clock.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Big M Towing Logo',
      businessName: 'Big M Towing LLC',
      contact: {
        phone: '2054962590',
        phoneLabel: '(205) 496-2590',
        email: 'bigmtrucking2410@yahoo.com',
        website: 'https://bigmtowing.com/',
        address: 'Eutaw, AL 35462, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Eutaw, AL 35462, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53850.49686184748!2d-87.9442072!3d32.8401281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8889aafc3a0fc35d%3A0xf7afc3294bb312e7!2sEutaw%2C%20AL%2035462%2C%20USA!5e0!3m2!1sen!2sus!4v1712702700000!5m2!1sen!2sus',
    },
  },
};

export default config;
